import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import ParentPortfolioFormContainer from '../../containers/parent-portfolio/ParentPortfolioFormContainer.jsx';

const EditParentPortfolio = ({ parentPortfolioId, query }) => {
  const portfolioId =
    parentPortfolioId || (query && query.parentPortfolioId)
      ? Number(parentPortfolioId || query.parentPortfolioId)
      : null;

  return (
    <>
      <Helmet>
        <title>Edit {getOrgTermsContent('parentPortfolio')} | ChangeSync</title>
      </Helmet>
      <ParentPortfolioFormContainer parentPortfolioId={portfolioId} />
    </>
  );
};

export default requireAuth(withRouterParams(EditParentPortfolio));
